"use client";

import { c as _c } from "react/compiler-runtime";
import { Page } from "@/types/pages";
import { findRouteByPath } from "@hooks/pages/use-route-info-utils";
import { useMemo } from "react";
import { usePathname } from "next/navigation";

/**
 * Type definition for the return value of useRouteInfo hook
 * @property {string} pathname - The current pathname
 * @property {Page | null} page - The route information for the current path or null if not found
 */
export type UseRouteInfo = {
  pathname: string;
  page: Page | null;
};

/**
 * Hook to get route information based on the current pathname
 * @returns The route information for the current path or null if not found
 */
export const useRouteInfo = () => {
  const $ = _c(5);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = findRouteByPath(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const page = t0;
  let t1;
  if ($[2] !== page || $[3] !== pathname) {
    t1 = {
      pathname,
      page
    };
    $[2] = page;
    $[3] = pathname;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};